export default [
    {
        "Request_Id": 160058,
        "cid": "3075",
        "Cust_Info": {
            "Cust_ID": "3075",
            "Cust_Name": "AHMAD KAMARUL ZAMAN BIN ZAKARIA",
            "Cust_DOB": "1982-12-19",
            "Cust_Age": "40",
            "Max_Tenure_Year": "30"
        },
        "Income_Info": {
            "plus_info": [
                // first income type get income type value
                {
                    customer_income_id: 1,
                    income_type: "Salaried",
                    customer_value: 10200.00,
                    customer_annual_value: 10200.00 * 12,
                    admin_value: null,
                    remark: null,
                },
                {
                    customer_income_id: 2,
                    income_type: "Fixed Allowance",
                    customer_value: 4400.00,
                    customer_annual_value: 4400.00 * 12,
                    admin_value: null,
                    remark: null,
                },
                {
                    customer_income_id: 3,
                    income_type: "Avg Variable Income",
                    customer_value: 0,
                    customer_annual_value: 0,
                    admin_value: null,
                    remark: null,
                },
                {
                    customer_income_id: 4,
                    income_type: "Avg Commission",
                    customer_value: 0,
                    customer_annual_value: 0,
                    admin_value: null,
                    remark: null,
                },
            ],
            bonus_income: {
                customer_income_id: 5,
                income_type: "Avg Bonus",
                customer_value: 220,
                customer_annual_value: 220 *12,
                admin_value: null,
                remark: null,
            },
            rental_income: {
                customer_income_id: 6,
                income_type: "Rental Income",
                customer_value: 6300,
                customer_annual_value: 6300*12,
                admin_value: null,
                remark: null,
                // if got child, then there is rental detail object, else not exist
                
                rental_detail: [
                    {
                        customer_income_id:11,
                        income_type:"Impiria Residence Tower C",
                        parent_customer_income_id: 6,
                        customer_value:2000,
                        customer_annual_value:2000*12,
                        admin_value: null,
                        remark: null,
                    },
                    {
                        customer_income_id:12,
                        income_type:"Impiria Residence Tower A",
                        parent_customer_income_id: 6,
                        customer_value:1800,
                        customer_annual_value:1800*12,
                        admin_value: null,
                        remark: null,
                    },
                    {
                        customer_income_id:13,
                        income_type:"Impiria Residence Tower B",
                        parent_customer_income_id: 6,
                        customer_value:2500,
                        customer_annual_value:2500*12,
                        admin_value: null,
                        remark: null,
                    },
                ]
                
            },
            gross_income: {
                customer_income_id: 7,
                income_type: "Gross Income",
                customer_value: 14600,
                customer_annual_value: 14600 * 12,
                admin_value: null,
                remark: null,
            },
            'minus_info': [
                {
                    customer_income_id: 8,
                    income_type: "Income Tax",
                    customer_value: 2628,
                    customer_annual_value: 2628 * 12,
                    admin_value: null,
                    remark: null,
                },
                {
                    customer_income_id: 9,
                    income_type: "Less:EPF Contribution",
                    customer_value: 1606,
                    customer_annual_value: 1606 * 12,
                    admin_value: null,
                    remark: null,
                },
                {
                    customer_income_id: 10,
                    income_type: "SOCSO",
                    customer_value: 19.75,
                    customer_annual_value: 19.75 * 12,
                    admin_value: null,
                    remark: null,
                },
            ],
            "Net_Income": 16866.25,
            "Annual_Net_Income": 16866.25 * 12,
        },
        "Bank_Info": [
            {
                "Bank_Id": 36,
                "Bank_Code": "BOC",
                "Bank_Name": "Bank of China",
                "Variable_Income_Rate": "70.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "70.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "100.00",
                "Rental_Income_Amt": "1200",
                "Min_Bonus_Year": "2",
                "Bonus_Year_1_Rate": "0.00",
                "Bonus_Year_2_Rate": "0.00",
                "Bonus_Year_3_Rate": "0.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "2",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "LHDN",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "1200",
                "Net_Income": "4495.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Net Income",
                "Accepted_Rate": "0",
                "Accepted_Income": "0",
                "In_Used": "-",
                "Urban_NDI": "1000.00",
                "Actual_DSR_Rate": "0.00",
                "DSR_NDI": "4495.42",
                "Final_Accept_Income": "0",
                "Installable_Amount": "-2894",
                "Installable_Amount_Without_NDI": "-2894",
                "Loan_Interest": "3.2500",
                "Tenure_Year": "31",
                "Loan_Eligible": "-677860.36"
            },
            {
                "Bank_Id": 26,
                "Bank_Code": "ABM",
                "Bank_Name": "Affin Bank",
                "Variable_Income_Rate": "80.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "80.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "100.00",
                "Rental_Income_Amt": "1200",
                "Min_Bonus_Year": "2",
                "Bonus_Year_1_Rate": "100.00",
                "Bonus_Year_2_Rate": "100.00",
                "Bonus_Year_3_Rate": "100.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "2",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "LHDN",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "1200",
                "Net_Income": "4495.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Gross Income",
                "Accepted_Rate": "60.00",
                "Accepted_Income": "2697.252",
                "In_Used": "-",
                "Urban_NDI": "1300.00",
                "Actual_DSR_Rate": "60.00",
                "DSR_NDI": "1798.168",
                "Final_Accept_Income": "2697.252",
                "Installable_Amount": "-196.748",
                "Installable_Amount_Without_NDI": "-196.748",
                "Loan_Interest": "3.6500",
                "Tenure_Year": "31",
                "Loan_Eligible": "-43784.56"
            },
            {
                "Bank_Id": 23,
                "Bank_Code": "AIA",
                "Bank_Name": "AIA",
                "Variable_Income_Rate": "50.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "50.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "80.00",
                "Rental_Income_Amt": "960",
                "Min_Bonus_Year": "2",
                "Bonus_Year_1_Rate": "0.00",
                "Bonus_Year_2_Rate": "80.00",
                "Bonus_Year_3_Rate": "0.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "2",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "LHDN",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "960",
                "Net_Income": "4255.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Net Income",
                "Accepted_Rate": "60.00",
                "Accepted_Income": "2553.252",
                "In_Used": "-",
                "Urban_NDI": "1300.00",
                "Actual_DSR_Rate": "60.00",
                "DSR_NDI": "1702.168",
                "Final_Accept_Income": "2553.252",
                "Installable_Amount": "-340.748",
                "Installable_Amount_Without_NDI": "-340.748",
                "Loan_Interest": "3.5500",
                "Tenure_Year": "31",
                "Loan_Eligible": "-76798.38"
            },
            {
                "Bank_Id": 2,
                "Bank_Code": "ALB",
                "Bank_Name": "Alliance Bank",
                "Variable_Income_Rate": "100.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "100.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "70.00",
                "Rental_Income_Amt": "840",
                "Min_Bonus_Year": "1",
                "Bonus_Year_1_Rate": "85.00",
                "Bonus_Year_2_Rate": "100.00",
                "Bonus_Year_3_Rate": "100.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "1",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "Alliance",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "840",
                "Net_Income": "4135.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Gross Income",
                "Accepted_Rate": "60.00",
                "Accepted_Income": "2481.252",
                "In_Used": "-",
                "Urban_NDI": "1000.00",
                "Actual_DSR_Rate": "60.00",
                "DSR_NDI": "1654.168",
                "Final_Accept_Income": "2481.252",
                "Installable_Amount": "-412.748",
                "Installable_Amount_Without_NDI": "-412.748",
                "Loan_Interest": "3.9000",
                "Tenure_Year": "31",
                "Loan_Eligible": "-89016.24"
            },
            {
                "Bank_Id": 4,
                "Bank_Code": "AMB",
                "Bank_Name": "AmBank",
                "Variable_Income_Rate": "85.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "85.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "85.00",
                "Rental_Income_Amt": "1020",
                "Min_Bonus_Year": "1",
                "Bonus_Year_1_Rate": "50.00",
                "Bonus_Year_2_Rate": "100.00",
                "Bonus_Year_3_Rate": "100.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "1",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "LHDN",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "1020",
                "Net_Income": "4315.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Gross Income",
                "Accepted_Rate": "60.00",
                "Accepted_Income": "2589.252",
                "In_Used": "-",
                "Urban_NDI": "0",
                "Actual_DSR_Rate": "60.00",
                "DSR_NDI": "1726.168",
                "Final_Accept_Income": "2589.252",
                "Installable_Amount": "-304.748",
                "Installable_Amount_Without_NDI": "-304.748",
                "Loan_Interest": "3.7000",
                "Tenure_Year": "31",
                "Loan_Eligible": "-67392.23"
            },
            {
                "Bank_Id": 33,
                "Bank_Code": "BMMB",
                "Bank_Name": "Bank Muamalat",
                "Variable_Income_Rate": "60.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "0.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "100.00",
                "Rental_Income_Amt": "1200",
                "Min_Bonus_Year": "1",
                "Bonus_Year_1_Rate": "100.00",
                "Bonus_Year_2_Rate": "0.00",
                "Bonus_Year_3_Rate": "0.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "1",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "Alliance",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "1200",
                "Net_Income": "4495.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Net Income",
                "Accepted_Rate": "70.00",
                "Accepted_Income": "3146.794",
                "In_Used": "-",
                "Urban_NDI": "0",
                "Actual_DSR_Rate": "70.00",
                "DSR_NDI": "1348.626",
                "Final_Accept_Income": "3146.794",
                "Installable_Amount": "252.794",
                "Installable_Amount_Without_NDI": "252.794",
                "Loan_Interest": "3.4000",
                "Tenure_Year": "31",
                "Loan_Eligible": "58077.73"
            },
            {
                "Bank_Id": 10,
                "Bank_Code": "BI",
                "Bank_Name": "Bank Islam",
                "Variable_Income_Rate": "50.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "100.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "50.00",
                "Rental_Income_Amt": "600",
                "Min_Bonus_Year": "1",
                "Bonus_Year_1_Rate": "50.00",
                "Bonus_Year_2_Rate": "50.00",
                "Bonus_Year_3_Rate": "0.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "1",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "LHDN",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "600",
                "Net_Income": "3895.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Gross Income",
                "Accepted_Rate": "60.00",
                "Accepted_Income": "2337.252",
                "In_Used": "-",
                "Urban_NDI": "1250.00",
                "Actual_DSR_Rate": "60.00",
                "DSR_NDI": "1558.168",
                "Final_Accept_Income": "2337.252",
                "Installable_Amount": "-556.748",
                "Installable_Amount_Without_NDI": "-556.748",
                "Loan_Interest": "3.8000",
                "Tenure_Year": "31",
                "Loan_Eligible": "-121581.89"
            },
            {
                "Bank_Id": 24,
                "Bank_Code": "BSN",
                "Bank_Name": "Bank Simpanan",
                "Variable_Income_Rate": "80.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "80.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "100.00",
                "Rental_Income_Amt": "1200",
                "Min_Bonus_Year": "1",
                "Bonus_Year_1_Rate": "100.00",
                "Bonus_Year_2_Rate": "100.00",
                "Bonus_Year_3_Rate": "100.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "1",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "LHDN",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "1200",
                "Net_Income": "4495.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Gross Income",
                "Accepted_Rate": "70.00",
                "Accepted_Income": "3146.794",
                "In_Used": "Yes",
                "Urban_NDI": "1400.00",
                "Actual_DSR_Rate": "68.86",
                "DSR_NDI": "1348.626",
                "Final_Accept_Income": "3095.546212",
                "Installable_Amount": "201.546212",
                "Installable_Amount_Without_NDI": "252.794",
                "Loan_Interest": "3.7500",
                "Tenure_Year": "31",
                "Loan_Eligible": "44290.46"
            },
            {
                "Bank_Id": 1,
                "Bank_Code": "CIMB",
                "Bank_Name": "CIMB Bank",
                "Variable_Income_Rate": "100.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "80.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "80.00",
                "Rental_Income_Amt": "960",
                "Min_Bonus_Year": "1",
                "Bonus_Year_1_Rate": "50.00",
                "Bonus_Year_2_Rate": "50.00",
                "Bonus_Year_3_Rate": "50.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "1",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "LHDN",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "960",
                "Net_Income": "4255.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Net Income",
                "Accepted_Rate": "80.00",
                "Accepted_Income": "3404.336",
                "In_Used": "-",
                "Urban_NDI": "800.00",
                "Actual_DSR_Rate": "80.00",
                "DSR_NDI": "851.084",
                "Final_Accept_Income": "3404.336",
                "Installable_Amount": "510.336",
                "Installable_Amount_Without_NDI": "510.336",
                "Loan_Interest": "3.8500",
                "Tenure_Year": "31",
                "Loan_Eligible": "110751.44"
            },
            {
                "Bank_Id": 12,
                "Bank_Code": "MBB",
                "Bank_Name": "Maybank",
                "Variable_Income_Rate": "70.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "70.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "70.00",
                "Rental_Income_Amt": "840",
                "Min_Bonus_Year": "2",
                "Bonus_Year_1_Rate": "0.00",
                "Bonus_Year_2_Rate": "70.00",
                "Bonus_Year_3_Rate": "70.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "2",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "LHDN",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "840",
                "Net_Income": "4135.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Gross Income",
                "Accepted_Rate": "40.00",
                "Accepted_Income": "1654.168",
                "In_Used": "-",
                "Urban_NDI": "1300.00",
                "Actual_DSR_Rate": "40.00",
                "DSR_NDI": "2481.252",
                "Final_Accept_Income": "1654.168",
                "Installable_Amount": "-1239.832",
                "Installable_Amount_Without_NDI": "-1239.832",
                "Loan_Interest": "3.6000",
                "Tenure_Year": "31",
                "Loan_Eligible": "-277666.46"
            },
            {
                "Bank_Id": 14,
                "Bank_Code": "MBSB",
                "Bank_Name": "MBSB",
                "Variable_Income_Rate": "25.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "25.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "60.00",
                "Rental_Income_Amt": "720",
                "Min_Bonus_Year": "1",
                "Bonus_Year_1_Rate": "60.00",
                "Bonus_Year_2_Rate": "60.00",
                "Bonus_Year_3_Rate": "60.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "1",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "LHDN",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "720",
                "Net_Income": "4015.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Gross Income",
                "Accepted_Rate": "70.00",
                "Accepted_Income": "2810.794",
                "In_Used": "-",
                "Urban_NDI": "1000.00",
                "Actual_DSR_Rate": "70.00",
                "DSR_NDI": "1204.626",
                "Final_Accept_Income": "2810.794",
                "Installable_Amount": "-83.206",
                "Installable_Amount_Without_NDI": "-83.206",
                "Loan_Interest": "4.0500",
                "Tenure_Year": "35",
                "Loan_Eligible": "-18665.31"
            },
            {
                "Bank_Id": 5,
                "Bank_Code": "PBB",
                "Bank_Name": "Public Bank",
                "Variable_Income_Rate": "70.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "70.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "100.00",
                "Rental_Income_Amt": "1200",
                "Min_Bonus_Year": "2",
                "Bonus_Year_1_Rate": "0.00",
                "Bonus_Year_2_Rate": "100.00",
                "Bonus_Year_3_Rate": "100.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "2",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "LHDN",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "1200",
                "Net_Income": "4495.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Gross Income",
                "Accepted_Rate": "60.00",
                "Accepted_Income": "2697.252",
                "In_Used": "-",
                "Urban_NDI": "1200.00",
                "Actual_DSR_Rate": "60.00",
                "DSR_NDI": "1798.168",
                "Final_Accept_Income": "2697.252",
                "Installable_Amount": "-196.748",
                "Installable_Amount_Without_NDI": "-196.748",
                "Loan_Interest": "3.6700",
                "Tenure_Year": "31",
                "Loan_Eligible": "-43674.04"
            },
            {
                "Bank_Id": 3,
                "Bank_Code": "RHB",
                "Bank_Name": "RHB Bank",
                "Variable_Income_Rate": "50.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "50.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "80.00",
                "Rental_Income_Amt": "960",
                "Min_Bonus_Year": "1",
                "Bonus_Year_1_Rate": "100.00",
                "Bonus_Year_2_Rate": "100.00",
                "Bonus_Year_3_Rate": "100.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "1",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "Alliance",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "960",
                "Net_Income": "4255.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Gross Income",
                "Accepted_Rate": "70.00",
                "Accepted_Income": "2978.794",
                "In_Used": "Yes",
                "Urban_NDI": "1300.00",
                "Actual_DSR_Rate": "69.45",
                "DSR_NDI": "1276.626",
                "Final_Accept_Income": "2955.38919",
                "Installable_Amount": "61.38919",
                "Installable_Amount_Without_NDI": "84.794",
                "Loan_Interest": "3.5500",
                "Tenure_Year": "31",
                "Loan_Eligible": "13836.00"
            },
            {
                "Bank_Id": 11,
                "Bank_Code": "UOB",
                "Bank_Name": "UOB Bank",
                "Variable_Income_Rate": "70.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "70.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "70.00",
                "Rental_Income_Amt": "840",
                "Min_Bonus_Year": "1",
                "Bonus_Year_1_Rate": "50.00",
                "Bonus_Year_2_Rate": "70.00",
                "Bonus_Year_3_Rate": "80.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "1",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "Alliance",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "840",
                "Net_Income": "4135.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Gross Income",
                "Accepted_Rate": "65.00",
                "Accepted_Income": "2688.023",
                "In_Used": "-",
                "Urban_NDI": "0",
                "Actual_DSR_Rate": "65.00",
                "DSR_NDI": "1447.397",
                "Final_Accept_Income": "2688.023",
                "Installable_Amount": "-205.977",
                "Installable_Amount_Without_NDI": "-205.977",
                "Loan_Interest": "3.5500",
                "Tenure_Year": "31",
                "Loan_Eligible": "-46423.46"
            },
            {
                "Bank_Id": 35,
                "Bank_Code": "KCP",
                "Bank_Name": "Co-Opbank",
                "Variable_Income_Rate": "70.00",
                "Variable_Income_Amt": "0",
                "Commission_Income_Rate": "70.00",
                "Commission_Income_Amt": "0",
                "Rental_Income_Rate": "100.00",
                "Rental_Income_Amt": "1200",
                "Min_Bonus_Year": "2",
                "Bonus_Year_1_Rate": "0.00",
                "Bonus_Year_2_Rate": "0.00",
                "Bonus_Year_3_Rate": "0.00",
                "Bonus_Year_1_Amt": "",
                "Bonus_Year_2_Amt": "",
                "Bonus_Year_3_Amt": "",
                "Accepted_Bonus_Year": "2",
                "Average_Bonus": "0",
                "Average_Bonus_After": "0",
                "Salary": "2530.42",
                "Business_Income": "0",
                "Fixed_Allowance": "765.00",
                "Variable_Income": "0",
                "Commission_Income": "0",
                "Gross_Income": "3295.42",
                "Default_Tax_Type": "LHDN",
                "EPF_Amount": "0",
                "Income_Tax": "0",
                "Income_Tax_Rate": "",
                "Socso_Amount": "0",
                "Bonus_Income": "0",
                "Rental_Income": "1200",
                "Net_Income": "4495.42",
                "Total_Commitment": "2894",
                "Accepted_Rate_Based": "Net Income",
                "Accepted_Rate": "80.00",
                "Accepted_Income": "3596.336",
                "In_Used": "Yes",
                "Urban_NDI": "1000.00",
                "Actual_DSR_Rate": "77.76",
                "DSR_NDI": "899.084",
                "Final_Accept_Income": "3495.638592",
                "Installable_Amount": "601.638592",
                "Installable_Amount_Without_NDI": "702.336",
                "Loan_Interest": "3.2500",
                "Tenure_Year": "31",
                "Loan_Eligible": "140921.55"
            }
        ],
    }
];